// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"498d1d59","242":"6fe2be69","318":"57729826","391":"9f630a91","418":"205d8286","531":"423dce76","591":"ca7cfc2a","649":"4bb94c6e","826":"edbb9e5a","871":"ede6afeb"}[chunkId] + ".chunk.js";
};